var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIconDynamic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#calendar-icon-dynamic_svg__clip0_1011_16281)",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.667 3.226H3.333C2.597 3.226 2 3.823 2 4.56v9.334c0 .736.597 1.333 1.333 1.333h9.334c.736 0 1.333-.597 1.333-1.333V4.559c0-.736-.597-1.333-1.333-1.333zM2 7.226h12M10.666 1.893v2.666M5.333 1.893v2.666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "calendar-icon-dynamic_svg__clip0_1011_16281"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .56)",
    d: "M0 0h16v16H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/calendar-icon-dynamic.0a3d8f59.svg";
export { SvgCalendarIconDynamic as ReactComponent };